module.exports = __webpack_public_path__ + "static/media/logo.996005d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/nav-bar/logo.png
// module id = 538
// module chunks = 0